import { render, staticRenderFns } from "./ForbiddenDrivers.vue?vue&type=template&id=6b24a630&scoped=true&lang=pug"
import script from "./ForbiddenDrivers.vue?vue&type=script&lang=js"
export * from "./ForbiddenDrivers.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenDrivers.vue?vue&type=style&index=0&id=6b24a630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b24a630",
  null
  
)

export default component.exports